import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../services/base/authentication.service';
import { takeUntil } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Organisation } from '../../../../interfaces/routering/organisation';
import { Subject } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'fury-other-apps-dialog',
  templateUrl: './other-apps-dialog.component.html',
  styleUrls: ['./other-apps-dialog.component.scss'],
})

export class OtherAppsDialogComponent implements OnInit, OnDestroy {

  public form = this.fb.group({});

  public taskNumberAbbreviation: string = 'SO';
  public years: number[] = [];
  public yearSelection: FormControl = new FormControl<number>(null);

  private destroy$: Subject<null> = new Subject<null>();

  constructor(
    private fb: FormBuilder,
    public authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    this.authenticationService.organisation$.pipe(takeUntil(this.destroy$)).subscribe((data: Organisation): void => {
      if (data) {
        this.taskNumberAbbreviation = data.name;

        if (data.domains) {
          data.domains.forEach((d) => {
            this.form.addControl(d.type.name, new FormGroup({
              task_type: new FormControl(<string>null),
              task_number: new FormControl(<string>null),
              task_unique_number: new FormControl(<string>null),
              isLoading: new FormControl(<boolean>false),
            }));
          });
        }
      }
    });

    const startDate: Date = new Date('January 1, 2018 00:00:00'),
      endDate: Date = new Date(),
      years: number = moment(endDate).diff(startDate, 'years');
    for (let year: number = 0; year <= years; year++) {
      this.years.push(parseInt((startDate.getFullYear() + year).toString().slice(1), 10));
    }

    this.yearSelection.setValue(this.years.slice(this.years.length - 1)[0], {emitEvent: false});
  }

  getOptionUrl(url: string, option: string): string {
    const element: string = this.form.controls[option]?.controls?.task_unique_number?.value;

    if (element !== undefined && typeof element === 'string') {
      return url + '/' + element;
    }

    return url;
  }

  log(): void {
    console.log(this.form);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
